<div class="modal-header {{ modalData.headerClasses }}" *ngIf="modalData.showHeader">
  <!-- NOTE Dynamic title -->
  <span *ngIf="modalData.showIcon">
    <img src="./assets/img/project/icons/{{modalData.icon}}">
  </span>
  <h6 class="modal-title">{{ modalData.title }}</h6>
  <button type="button" class="btn-close" *ngIf="modalData.closable" aria-label="Close" (click)="activeModal.dismiss()">
  </button>
</div>

<!-- NOTE Component -->
<!-- <ng-template modal-wrapper-host>
    {{ modalWrapperHost }}
  </ng-template> -->

<div class="modal-body auto {{ modalData.bodyClasses }}">
  <!-- Display dynamic content -->
  <p> {{ modalData.content }} </p>

  <div *ngIf="modalData.showButton">
    <button type="button" class="btn btn-outline-secondary btn-ok" (click)="submitClose()">Ok</button>
  </div>

</div>

<div class="modal-footer" *ngIf="modalData.showFooter">
  <button type="button" class="btn btn-primary btn-submit" (click)="submitData()">Yes</button>
  <button type="button" class="btn btn-outline-secondary btn-cancel" (click)="submitClose()">No</button>
</div>